import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="todo-app">
      <h1>ToDo List App</h1>
      
      <TodoList/>
    </div>
  );
}

export default App;
